// extracted by mini-css-extract-plugin
export const root = "icon-module--root--3vyv5";
export const icon = "icon-module--icon--kd_nd";
export const label = "icon-module--label--2pyff";